import { useDispatch, useSelector } from "react-redux";
import { setErrors } from "../../../store/alerts/alertsActions";
import { useEffect, useState } from "react";
import { get, post } from "../../../api";
import useFacility from "../../../../utils/hooks/useFacility";
import { GET_BASKET_QB, SAVE_BASKET_QB } from "../../../api/apiRoutes";
import { QbBasketData } from "../../../models/QnBasketData";
import { State } from "../../../store";
import { BasketItem } from "../../../models/BasketItem";
import { UNKNOWN_ERROR } from "../../../api/tryCatchRequest";

/* eslint-disable import/no-anonymous-default-export */
export default (onClose: () => void) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<QbBasketData>({} as QbBasketData);
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const basketLength = useSelector((state: State) => state.basket.basketLength);

  const getBasketQb = async () => {
    setLoading(true);
    const { result, isError, errorTable } = await get(GET_BASKET_QB(facilityIds));
    if (!isError) {
      setData(result);
    } else {
      dispatch(setErrors(errorTable));
    }
    setLoading(false);
  };

  useEffect(() => {
    getBasketQb();
    //eslint-disable-next-line
  }, []);

  const updateBasketItem = (index: number, key: "qb_card" | "qb_pin", value: string) => {
    const updatedBasket = [...data.basket];
    updatedBasket[index] = { ...updatedBasket[index], [key]: value };
    setData({ ...data, basket: updatedBasket });
  };

  const onUpdateBasket = async () => {
    setLoading(true);
    const { result, isError, errorTable } = await post(SAVE_BASKET_QB(facilityIds), { basket: data.basket });
    if (!isError) {
      if (result) {
        const hasInvalidDiscount = result.some(
          (item: BasketItem) => item.qb_znizka_id <= 0 && Boolean(item.qb_message)
        );
        if (hasInvalidDiscount) {
          setData({ ...data, basket: result });
        } else {
          setData({} as QbBasketData);
          onClose();
        }
      } else {
        dispatch(setErrors([UNKNOWN_ERROR]));
      }
    } else {
      dispatch(setErrors(errorTable));
    }
    setLoading(false);
  };

  return { loading, data, updateBasketItem, onUpdateBasket, basketLength };
};
